import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import ClickAwayListener from "react-click-away-listener";
import DatePicker from "react-datepicker";
import { Home as IconHome } from "react-feather";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { translate } from "react-switch-lang";
import { toast } from "react-toastify";
import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Form, FormGroup, Input, Modal, ModalBody, Row } from "reactstrap";
import { CategoryDto } from "../../models/categoryDto";
import { CountryDto } from "../../models/countryDto";
import { DocumentTypeDto } from "../../models/documentTypeDto";
import { SupportDto } from "../../models/supportDto";
import { ThematicDto } from "../../models/thematicDto";
import { ThematicModel } from "../../models/thematicModel";
import { VideoTypeDto } from "../../models/videoTypeDto";
import hasRoles from "../../security/hasRoles";
import { useHttpClient } from "../../security/hooks/axiosProvider";
import keycloak from "../../security/keycloak-config";
import { RootState } from "../../store";
import Header from "../header/header";
import Documents from "../media/Document/documents";
import GalleryImages from "../media/Exposition/gallery-images/GalleryImages";
import Videotheque from "../media/Video/videotheque";
import Pagination from "../pagination/pagination";
import AddImagesGallery from "../Support/add-images-gallery/addImagesGallery";
import AddSupport from "../Support/add-support/addSupport";
import AddVideo from "../Support/add-video/addVideo";
import Footer from "../template/footer";
import ThematicFolder from "../thematic-folder/thematicFolder";
import styles from "./categoryDetails.module.scss";

const CategoryDetails: React.FC<{ t: (key: string) => {} }> = props => {
  toast.configure();
  let countryRef = React.useRef(null);
  let resetRef = React.useRef(null);
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const location = useLocation();
  const httpClient = useHttpClient(false);
  const [category, setCategory] = useState<CategoryDto>(new CategoryDto());
  const [openModalAddSupport, setOpenModalAddSupport] = useState<boolean>(false);
  const [listTypeDocument, setListTypeDocument] = useState<DocumentTypeDto[]>([]);
  const [listTypeVideo, setListTypeVideo] = useState<VideoTypeDto[]>([]);
  const [listThematic, setListThematic] = useState<ThematicModel[]>([]);
  const [listCountry, setListCountry] = useState<CountryDto[]>([]);
  const [listLanguage, setListLanguage] = useState<string[]>(["Français", "Anglais"]);
  const [isListDisplayMode, setIsListDisplayMode] = useState<boolean>(true);
  const [totalElement, setTotlaElement] = useState<number>(0);
  const [sortColumn, setSortColumn] = useState("title");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortColumnExpo, setSortColumnExpo] = useState("titleFr");
  const [isShowSearch, setIsShowSearch] = useState<boolean>(false);

  const [toggleDropdownDocumentType, setToggleDropdownDocumentType] = useState(false);
  const [toggleDropdownVideoType, setToggleDropdownVideoType] = useState(false);
  const [toggleDropdownThematic, setToggleDropdownThematic] = useState(false);
  const [toggleDropdownCountry, setToggleDropdownCountry] = useState(false);
  const [toggleDropdownLanguage, setToggleDropdownLanguage] = useState(false);
  const [viewdropdown, setViewdropdown] = useState(false);

  const [fieldSearchDocumentType, setFieldSearchDocumentType] = useState<DocumentTypeDto>(null);
  const [fieldSearchVideoType, setFieldSearchVideoType] = useState<VideoTypeDto>(null);
  const [fieldSearchThematic, setFieldSearchThematic] = useState<ThematicDto>(null);
  const [fieldSearchCountry, setFieldSearchCountry] = useState<CountryDto>(null);
  const [fieldSearchLanguage, setFieldSearchLanguage] = useState<string>(null);
  const [fieldSearchTitle, setFieldSearchTitle] = useState<string>(null);
  const [pageNumbers, setPageNumbers] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [elementPerPage] = useState(8);
  const [sortOrder, setSortOrder] = useState("ASC");

  const { register, handleSubmit, setValue, reset, getValues } = useForm({
    mode: "onChange",
    defaultValues: {
      title: "",
      documentTypeId: "",
      videoTypeId: "",
      thematicId: "",
      language: "",
      countryId: "",
      dateSupport: "",
    },
  });

  // Search Fields State
  const [filteredDocuments, setFilteredDocuments] = useState<SupportDto[]>([]);
  const [, setFilteredDocumentsSearch] = useState<SupportDto[]>([]);
  const [searchFieldDate, setSearchFieldDate] = useState<any>("");

  const handleClickOpenModalAddSupport = () => {
    setOpenModalAddSupport(!openModalAddSupport);
  };

  const handleClickAddSupport = () => {
    setOpenModalAddSupport(!openModalAddSupport);
  };

  const resetAllFieldSearch = () => {
    setCurrentPage(0);
    setSearchFieldDate(null);
    setFieldSearchDocumentType(null);
    setFieldSearchVideoType(null);
    setFieldSearchThematic(null);
    setFieldSearchCountry(null);
    setFieldSearchLanguage(null);
    setFieldSearchTitle(null);
    countryRef.current?.clear();
    reset();
  };

  const resetFormSeacrch = () => {
    resetAllFieldSearch();
    setCurrentPage(0);
    let params = { categoryId: category.categoryId, sortDirection: "DESC", sortColumn: "dateSupport", page: "0", size: elementPerPage };
    if (+category.typeCategory === 0) {
      httpClient.current?.get("/support/search", { params: params }).then(res => {
        setFilteredDocuments(res.data.content.map((data: any) => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
        setPageNumbers(res.data.totalPages);
        setTotlaElement(res.data.totalElements);
      });
    } else if (+category.typeCategory === 1) {
      httpClient.current?.get("/support_video/search", { params: params }).then(res => {
        setFilteredDocuments(res.data.content.map((data: any) => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
        setPageNumbers(res.data.totalPages);
        setTotlaElement(res.data.totalElements);
      });
    } else {
      setSortColumnExpo(selectedLanguage === "en" ? "titleEn" : "titleFr");
      params.sortColumn = selectedLanguage === "en" ? "titleEn" : "titleFr";
      httpClient.current?.get("/exposition/search", { params: params }).then(res => {
        setFilteredDocuments(res.data.content.map((data: any) => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
        setPageNumbers(res.data.totalPages);
        setTotlaElement(res.data.totalElements);
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.addEventListener(
      "contextmenu",
      function (e) {
        e.preventDefault();
        return false;
      },
      false,
    );
    httpClient.current?.get("/category/" + location.pathname.split("/")[3]).then(response => {
      setCategory(response.data);
      if (+response.data.typeCategory === 0) {
        let params = { categoryId: response.data.categoryId, sortDirection: sortOrder, sortColumn: "title", page: "0", size: elementPerPage };
        httpClient.current?.get("/support/search", { params: params }).then(res => {
          setFilteredDocuments(res.data.content.map(data => data.content));
          setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
          setTotlaElement(res.data.totalElements);
          setPageNumbers(res.data.totalPages);
          let byOrderParams = { categoryId: response.data.categoryId, language: "en", sortColumn: "SUPPORT_TITLE", asc: true };
          httpClient.current?.get("/support/byOrder", { params: byOrderParams }).then(result => {
            handleGetListOptionSearch(result.data, +response.data.typeCategory);
          });
        });
      } else if (+response.data.typeCategory === 1) {
      let params = { categoryId: response.data.categoryId, sortDirection: "DESC", sortColumn: "dateSupport", page: "0", size: elementPerPage };
      httpClient.current?.get("/support_video/search", { params: params }).then(res => {
        setFilteredDocuments(res.data.content.map(data => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
        setTotlaElement(res.data.totalElements);
        setPageNumbers(res.data.totalPages);
        let byOrderParams = { categoryId: response.data.categoryId, language: "en", sortColumn: "SUPPORT_DATE", asc: false };
        httpClient.current?.get("/support_video/byOrder", { params: byOrderParams }).then(result => {
          handleGetListOptionSearch(result.data, +response.data.typeCategory);
        });
      });
    }else {
        let params = { categoryId: response.data.categoryId,  sortDirection: "DESC", sortColumn: "dateExposition", page: "0", size: elementPerPage };
        httpClient.current?.get("/exposition/search", { params: params }).then(res => {
          setFilteredDocuments(res.data.content.map(data => data.content));
          setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
          setTotlaElement(res.data.totalElements);
          setPageNumbers(res.data.totalPages);
          httpClient.current?.get("/exposition", { params: { categoryId: response.data.categoryId } }).then(result => {
            handleGetListOptionSearch(result.data, +response.data.typeCategory);
          });
        });
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient, document]);
      
  const handleGetListOptionSearch = async (listMedia, typeCatgory) => {
        if (listMedia.length === 0) {
          setListTypeDocument([]);
          setListTypeVideo([]);
          setListThematic([]);
          setListCountry([]);
          setListLanguage([]);
        } else {
          if (typeCatgory === 0) {
            handleGetListOptionDocumentType(listMedia);
            handleGetListOptionLanguage(listMedia);
          } else if (typeCatgory === 1) {
            handleGetListOptionVideoType(listMedia);
            handleGetListOptionLanguage(listMedia);
          } else if (typeCatgory === 2) {
            handleGetListOptionLanguage(listMedia);
          }

          handleGetListOptionThematic(listMedia);
          handleGetListOptionCountry(listMedia);
        }
      };

  const handleGetListOptionLanguage = (listMedia: any[]) => {
    const langs: string[] = [];

    listMedia.forEach(media => {
      if (media.language && !langs.includes(media.language)) {
        langs.push(media.language);
      }
      else if (!media.language) {
        if (media.titleFr && !langs.includes("Français")) langs.push("Français");
        if (media.titleEn && !langs.includes("Anglais")) langs.push("Anglais");
      }
    });

    setListLanguage(langs);
  };


  const handleGetListOptionCountry = listMedia => {
    let listCountry = [];
    listMedia
      .map(element => element.listCountry)
      .flat()
      .forEach(countryObject => {
        if (listCountry.length === 0) {
          listCountry.push(countryObject);
          setListCountry(listCountry);
        } else {
          if (listCountry.map(element => element.countryId).indexOf(countryObject.countryId) < 0) {
            listCountry.push(countryObject);
            setListCountry(listCountry);
          }
        }
      });
  };

  const handleGetListOptionThematic = listMedia => {
    let listThematic = [];
    listMedia
      .map(element => element.listThematic)
      .flat()
      .forEach(thematicObject => {
        if (listThematic.length === 0) {
          listThematic.push(thematicObject);
          setListThematic(listThematic);
        } else {
          if (listThematic.map(element => element.thematicId).indexOf(thematicObject.thematicId) < 0) {
            listThematic.push(thematicObject);
            setListThematic(listThematic);
          }
        }
      });
  };

  const handleGetListOptionVideoType = (listMedia: any) => {
    let listVideoType = [];
    listMedia
      .map(element => element.videoType)
      .forEach((videoType: any) => {
        if (listVideoType.length === 0) {
          listVideoType.push(videoType);
          setListTypeVideo(listVideoType);
        } else {
          if (listVideoType.map(element => element.videoTypeId).indexOf(videoType.videoTypeId) < 0) {
            listVideoType.push(videoType);
            setListTypeVideo(listVideoType);
          }
        }
      });
  };

  const handleGetListOptionDocumentType = listMedia => {
    let listTypeDocument = [];
    listMedia
      .map(element => element.documentType)
      .forEach((documentType: any) => {
        if (listTypeDocument.length === 0) {
          listTypeDocument.push(documentType);
          setListTypeDocument(listTypeDocument);
        } else {
          if (listTypeDocument.map(element => element.documentTypeId).indexOf(documentType.documentTypeId) < 0) {
            listTypeDocument.push(documentType);
            setListTypeDocument(listTypeDocument);
          }
        }
      });
  };

  const handleGetListSupport = () => {
    if (+category.typeCategory === 0) {
      let params = { categoryId: category.categoryId, sortDirection: sortOrder, sortColumn: "title", page: "0", size: elementPerPage };
      httpClient.current?.get("/support/search", { params: params }).then(res => {
        setFilteredDocuments(res.data.content.map(data => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
        setCurrentPage(0);
        setPageNumbers(res.data.totalPages);
        let byOrderParams = { categoryId: category.categoryId, language: "en", sortColumn: "SUPPORT_DATE", asc: true };
        httpClient.current?.get("/support/byOrder", { params: byOrderParams }).then(result => {
          handleGetListOptionSearch(result.data, +category.categoryId);
        });
      });
    } else if (+category.typeCategory === 1) {
    let params = { categoryId: category.categoryId, sortDirection: "DESC", sortColumn: "dateSupport", page: "0", size: elementPerPage };
    httpClient.current?.get("/support_video/search", { params: params }).then(res => {
      setFilteredDocuments(res.data.content.map(data => data.content));
      setPageNumbers(res.data.totalPages);
      setCurrentPage(0);
      setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
      let byOrderParams = { categoryId: category.categoryId, language: "en", sortColumn: "SUPPORT_DATE", asc: false };
      httpClient.current?.get("/support_video/byOrder", { params: byOrderParams }).then(result => {
        handleGetListOptionSearch(result.data, +category.categoryId);
      });
    });
    } else {
      let params = { categoryId: +category.categoryId, sortDirection: sortOrder, sortColumn: selectedLanguage === "en" ? "titleEn" : "titleFr", page: "0", size: elementPerPage };
      httpClient.current?.get("/exposition/search", { params: params }).then(res => {
        setFilteredDocuments(res.data.content.map(data => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
        setPageNumbers(res.data.totalPages);
        setCurrentPage(0);
        httpClient.current?.get("/exposition", { params: { categoryId: category.categoryId } }).then(result => {
          handleGetListOptionSearch(result.data, +category.typeCategory);
        });
      });
    }
  };

  const paginateAndSorting = (index: any, e: any) => {
    let data: any = getValues();
    if (e) {
      e.preventDefault();
    }
    setCurrentPage(index.page ?? index);
    if (index.sortDirection) {
      setSortOrder(index.sortDirection);
    }
    data.categoryId = category.categoryId;
    data.sortDirection = index.sortDirection ?? sortOrder;
    data.page = index.page ?? index.toString();
    data.size = elementPerPage;

    if (+category.typeCategory === 0) {
      if (index.sortColumn) {
        setSortColumn(index.sortColumn);
      }
      data.sortColumn = index.sortColumn ?? sortColumn;
      httpClient.current?.get("/support/search", { params: data }).then(res => {
        setFilteredDocuments(res.data.content.map(data => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
      });
    } else if (+category.typeCategory === 1) {
    if (index.sortColumn) {
      setSortColumn(index.sortColumn);
    }
    data.sortColumn = index.sortColumn ?? "dateSupport";
    data.sortDirection = index.sortDirection ?? "DESC";
    httpClient.current?.get("/support_video/search", { params: data }).then(res => {
      setFilteredDocuments(res.data.content.map(data => data.content));
      setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
    });
    } 
    else {
        if (index.sortColumn) {
          setSortColumnExpo(index.sortColumn);}
        data.sortColumn = "dateExposition";
        data.sortDirection = "DESC";
        if (selectedLanguage === "en") {
          data.titleEn = data.title;
        } else {
          data.titleFr = data.title;
        }
        httpClient.current?.get("/exposition/search", { params: data }).then(res => {
          setFilteredDocuments(res.data.content.map(d => d.content));
          setFilteredDocumentsSearch(res.data.content.map((d: any) => d.content));
        });
      }};
  const onSubmit = (data: any) => {
    setCurrentPage(0);
    data.categoryId = category.categoryId;
    data.sortDirection = sortOrder;
    data.sortColumn = "title";
    data.page = "0";
    data.size = elementPerPage;
    if (+category.typeCategory === 0) {
      httpClient.current?.get("/support/search", { params: data }).then(res => {
        setFilteredDocuments(res.data.content.map(data => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
        setTotlaElement(res.data.totalElements);
        setPageNumbers(res.data.totalPages);
      });
    } else if (+category.typeCategory === 1) {
      httpClient.current?.get("/support_video/search", { params: data }).then(res => {
        setFilteredDocuments(res.data.content.map(data => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
        setTotlaElement(res.data.totalElements);
        setPageNumbers(res.data.totalPages);
      });
    } else {
      data.sortColumn = data.language === "Anglais" ? "titleEn" : data.language === "Français" ? "titleFr" : selectedLanguage === "en" ? "titleEn" : "titleFr";
      httpClient.current?.get("/exposition/search", { params: data }).then(res => {
        setFilteredDocuments(res.data.content.map(data => data.content));
        setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
        setTotlaElement(res.data.totalElements);
        setPageNumbers(res.data.totalPages);
      });
    }
  };

  const handleSetFieldDocumentType = (documentType: DocumentTypeDto) => {
    setFieldSearchDocumentType(documentType);
    setToggleDropdownDocumentType(false);
    setValue("documentTypeId", String(documentType.documentTypeId));
    // handleUpdateListOptionUsingDocumentType(documentType);
  };

  const handleSetFieldVideoType = (videoType: VideoTypeDto) => {
    setFieldSearchVideoType(videoType);
    setToggleDropdownVideoType(false);
    setValue("videoTypeId", String(videoType.videoTypeId));
  };

  const handleSetFieldThematic = (thematic: ThematicDto) => {
    setFieldSearchThematic(thematic);
    setToggleDropdownThematic(false);
    setValue("thematicId", String(thematic.thematicId));
  };

  const handleSetFieldCountry = (country: CountryDto) => {
    setFieldSearchCountry(country);
    setToggleDropdownCountry(false);
    setValue("countryId", String(country.countryId));
  };

  const handleSetFieldLanguage = (language: string) => {
    setFieldSearchLanguage(language);
    setToggleDropdownLanguage(false);
    setValue("language", language);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearchByTitle = useCallback(
    _.debounce((_searchVal: string, category: CategoryDto) => {
      setValue("title", _searchVal);
      let data: any = getValues();
      data.categoryId = category.categoryId;
      data.sortDirection = sortOrder;
      data.page = "0";
      data.size = elementPerPage;
      if (+category.typeCategory === 0) {
        httpClient.current?.get("/support/search", { params: data }).then(res => {
          setFilteredDocuments(res.data.content.map(data => data.content));
          setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
          setPageNumbers(res.data.totalPages);
          setTotlaElement(res.data.totalElements);
        });
      } else if (+category.typeCategory === 1) {
        httpClient.current?.get("/support_video/search", { params: data }).then(res => {
          setFilteredDocuments(res.data.content.map(data => data.content));
          setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
          setTotlaElement(res.data.totalElements);
          setPageNumbers(res.data.totalPages);
        });
      } else {
        if (selectedLanguage === "en") {
          data.titleEn = data.title;
        } else {
          data.titleFr = data.title;
        }
          data.sortColumn = "dateExposition";
          data.sortDirection = "DESC";        
          httpClient.current?.get("/exposition/search", { params: data }).then(res => {
          setFilteredDocuments(res.data.content.map(data => data.content));
          setFilteredDocumentsSearch(res.data.content.map((data: any) => data.content));
          setTotlaElement(res.data.totalElements);
          setPageNumbers(res.data.totalPages);
        });
      }
    }, 1000),
    [],
  );

  const handleSetListMedia = (listMedia: any) => {
    setCurrentPage(0);
    setFilteredDocuments(listMedia);
    handleGetListOptionSearch(listMedia, +category.typeCategory);
    setSearchFieldDate(null);
    setFieldSearchDocumentType(null);
    setFieldSearchVideoType(null);
    setFieldSearchThematic(null);
    setFieldSearchCountry(null);
    setFieldSearchLanguage(null);
    setFieldSearchTitle(null);
    countryRef.current?.clear();
    reset();
  };

  const viewSelection = () => {
    setViewdropdown(!viewdropdown);
  };

  return (
    <>
      {+category.typeCategory !== 3 ? (
        <div className="page-wrapper compact-wrapper" id="pageWrapper">
          <Header />
          <div className="page-body-wrapper">
            <div className={`${styles["agrisud-page-body"]} page-body`}>
              <Container className="search-page" fluid>
                <div className={styles["category_page-title"] + " page-title"}>
                  <Row>
                    <Breadcrumb>
                      <BreadcrumbItem>
                        <Link to={`/`}>
                          <IconHome />
                        </Link>
                      </BreadcrumbItem>
                      {/* <BreadcrumbItem>
                          <Link to={`${process.env.PUBLIC_URL}/`}>Accueil</Link>
                        </BreadcrumbItem> */}
                      <BreadcrumbItem active>{selectedLanguage === "en" ? category?.titleAnglais : category?.titleFrancais}</BreadcrumbItem>
                    </Breadcrumb>
                  </Row>
                </div>
                <Row>
                  {+category.typeCategory !== 3 ? (
                    <Col md={12}>
                      <div className={styles["ex3"]}>
                        <div className={styles["action-section"]}>
                          <div className={styles["section-total-element"]}>
                            <span className={styles["total-element"] + " m-l-5"}>{totalElement} </span>
                            <span className={styles["title-number__document"]}>
                              {+category.typeCategory === 0 ? props.t("title_documents") : +category.typeCategory === 1 ? props.t("title_videos") : props.t("title_exhibit")}
                            </span>
                          </div>
                          {window.outerWidth > 700 && (
                            <ClickAwayListener onClickAway={() => setViewdropdown(false)}>
                              <div className={`${styles["translate_wrapper-view"]} ${viewdropdown ? styles["active"] : ""}`}>
                                <div className={styles["current_lang-view"]}>
                                  <div className={styles["lang-view"] + " " + styles["label-list-view"]} onClick={() => viewSelection()}>
                                    <i className={`fa fa-eye  ${styles["fa-font-size"]} `}></i>
                                    {isListDisplayMode ? props.t("button_view_icon") : props.t("button_view_list")}
                                  </div>
                                </div>
                                <div className={`${styles["more_lang-view"]} ${viewdropdown ? styles["active"] : ""}`}>
                                  <div
                                    className={styles["lang-view"]}
                                    onClick={() => {
                                      viewSelection();
                                      setIsListDisplayMode(false);
                                    }}
                                  >
                                    <i className="fa fa-list m-t-5"></i>
                                    <span className={styles["lang-txt-view"]}>{props.t("button_view_list")}</span>
                                  </div>

                                  <div
                                    className={styles["lang-view"]}
                                    onClick={() => {
                                      viewSelection();
                                      setIsListDisplayMode(true);
                                    }}
                                  >
                                    <i className="fa fa-th-large m-t-5"></i>
                                    <span className={styles["lang-txt-view"]}>{props.t("button_view_icon")}</span>
                                  </div>
                                </div>
                              </div>
                            </ClickAwayListener>
                          )}
                          <div className={!isShowSearch ? styles["label-list-view"] + " " + styles["label-list-view-active"] : styles["label-list-view"]}>
                            <span onClick={() => setIsShowSearch(!isShowSearch)}>
                              <i title="Seacrh" className={isShowSearch ? `fa fa-sliders  ${styles["fa-font-size"]}` : `fa fa-sliders ${styles["fa-font-size"]}`}></i> {props.t("button_filter")}
                            </span>
                          </div>
                          {hasRoleAdmin && (
                            <div className={styles["btn-add-support"]}>
                              <Button onClick={() => handleClickAddSupport()} outline color="success" className={styles["add-btn"] + " m-r-20"}>
                                {+category?.typeCategory === 0 ? props.t("button_add_pdf") : +category?.typeCategory === 1 ? props.t("button_add_video") : props.t("button_add_expo")}
                              </Button>
                            </div>
                          )}
                        </div>
                        <Input onChange={() => { }} className={styles["checkbox-hide_show"]} checked={isShowSearch} type="checkbox" id="item-3" />
                        <div className={styles["hide3"]}>
                          <div className={styles["inner3"]}>
                            <div className={styles["category-details-card"]}>
                              {/* <CardHeader> */}
                              <Form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                  <Col md={4}>
                                    <FormGroup>
                                      <Input
                                        className={fieldSearchTitle !== "" && fieldSearchTitle !== null ? styles["field-selected__search"] : ""}
                                        type="text"
                                        {...register("title")}
                                        placeholder={String(props.t("filters.input_placeholder_search"))}
                                        bsSize="sm"
                                        value={getValues().title}
                                        onChange={e => {
                                          setValue("title", e.target.value);
                                          setFieldSearchTitle(e.target.value);
                                          handleSearchByTitle(e.target.value.trim(), category);
                                          // handleUpdateListOptionUsingTitle(e.target.value);
                                        }}
                                      />
                                      {fieldSearchTitle !== null && fieldSearchTitle !== "" && (
                                        <i
                                          onClick={e => {
                                            e.stopPropagation();
                                            setValue("title", "");
                                            setFieldSearchTitle(null);
                                            // handleGetListOptionSearch(filteredDocuments, +category.typeCategory);
                                            onSubmit(getValues());
                                          }}
                                          className={styles["icon-reset-filed"] + " fa fa-times"}
                                        ></i>
                                      )}
                                    </FormGroup>
                                  </Col>
                                  {(
                                    <Col md={4}>
                                      <FormGroup>
                                        {+category?.typeCategory === 0 ? (
                                          <ClickAwayListener onClickAway={() => setToggleDropdownDocumentType(false)}>
                                            <div
                                              className={` ${styles["translate_wrapper"]} ${toggleDropdownDocumentType ? styles["active"] : fieldSearchDocumentType ? styles["field-selected__search"] : ""
                                                }`}
                                            >
                                              <div className={styles["current_lang"]}>
                                                <div
                                                  className={styles["lang"]}
                                                  onClick={() => {
                                                    setToggleDropdownDocumentType(!toggleDropdownDocumentType);
                                                    setToggleDropdownCountry(false);
                                                    
                                                  }}
                                                >
                                                  {fieldSearchDocumentType ? (
                                                    <>
                                                      <a href="#thumb" className={styles["thumbnail"]}>
                                                        <img className="img-30 b-r-5" src={fieldSearchDocumentType.urlImage + "/preview"} alt="" />
                                                        <span>
                                                          <img className="b-r-10" src={fieldSearchDocumentType.urlImage + "/preview"} alt="" />
                                                        </span>
                                                      </a>
                                                      <span className={styles["lang-txt"]}>{fieldSearchDocumentType.titleFrancais}</span>
                                                      <i
                                                        onClick={e => {
                                                          e.stopPropagation();
                                                          setValue("documentTypeId", "");
                                                          setFieldSearchDocumentType(null);
                                                          setToggleDropdownDocumentType(false);
                                                          // handleGetListOptionSearch(filteredDocuments, +category.typeCategory);
                                                          onSubmit(getValues());
                                                        }}
                                                        className={styles["icon-reset-filed"] + " fa fa-times"}
                                                      ></i>
                                                    </>
                                                  ) : (
                                                    String(props.t("filters.input_placeholder_document_type"))
                                                  )}
                                                </div>
                                              </div>
                                              <div className={`${styles["more_lang"]} ${toggleDropdownDocumentType ? styles["active"] : ""}`}>
                                                {listTypeDocument.map(element => {
                                                  return (
                                                    <div
                                                      key={element.documentTypeId}
                                                      className={styles["lang"]}
                                                      onClick={() => {
                                                        handleSetFieldDocumentType(element);
                                                        onSubmit(getValues());
                                                      }}
                                                    >
                                                      <a href="#thumb" className={styles["thumbnail"]}>
                                                        <img className="img-30 b-r-5" src={element.urlImage + "/preview"} alt="" />
                                                        <span>
                                                          <img className="b-r-10" src={element.urlImage + "/preview"} alt="" />
                                                        </span>
                                                      </a>
                                                      <span className={styles["lang-txt"]}>{selectedLanguage === "en" ? element.titleAnglais : element.titleFrancais}</span>
                                                    </div>
                                                  );
                                                })}
                                                {listTypeDocument.length === 0 && (
                                                  <div className={styles["lang"] + " text-center"}>
                                                    <span className={styles["lang-txt-vide"] + " text-center"}>---Vide---</span>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </ClickAwayListener>
                                        ) : (
                                          <ClickAwayListener onClickAway={() => setToggleDropdownVideoType(false)}>
                                            <div
                                              className={` ${styles["translate_wrapper"]} ${toggleDropdownVideoType ? styles["active"] : fieldSearchVideoType ? styles["field-selected__search"] : ""}`}
                                            >
                                              <div className={styles["current_lang"]}>
                                                <div
                                                  className={styles["lang"]}
                                                  onClick={() => {
                                                    setToggleDropdownVideoType(!toggleDropdownVideoType);
                                                    setToggleDropdownCountry(false);
                                                    setToggleDropdownLanguage(false);
                                                  }}
                                                >
                                                  {fieldSearchVideoType ? (
                                                    <>
                                                      <a href="#thumb" className={styles["thumbnail"]}>
                                                        <img className="img-30 b-r-5" src={fieldSearchVideoType.urlImage + "/preview"} alt="" />
                                                        <span>
                                                          <img className="b-r-10" src={fieldSearchVideoType.urlImage + "/preview"} alt="" />
                                                        </span>
                                                      </a>
                                                      <span className={styles["lang-txt"]}>{fieldSearchVideoType.titleFrancais}</span>
                                                      <i
                                                        onClick={e => {
                                                          e.stopPropagation();
                                                          setValue("videoTypeId", "");
                                                          setFieldSearchVideoType(null);
                                                          setToggleDropdownVideoType(false);
                                                          // handleGetListOptionSearch(filteredDocuments, +category.typeCategory);
                                                          onSubmit(getValues());
                                                        }}
                                                        className={styles["icon-reset-filed"] + " fa fa-times"}
                                                      ></i>
                                                    </>
                                                  ) : (
                                                    String(props.t("filters.input_placeholder_video_type"))
                                                  )}
                                                </div>
                                              </div>
                                              <div className={`${styles["more_lang"]} ${toggleDropdownVideoType ? styles["active"] : ""}`}>
                                                {listTypeVideo.map(element => {
                                                  return (
                                                    <div
                                                      key={element.videoTypeId}
                                                      className={styles["lang"]}
                                                      onClick={() => {
                                                        handleSetFieldVideoType(element);
                                                        onSubmit(getValues());
                                                      }}
                                                    >
                                                      <a href="#thumb" className={styles["thumbnail"]}>
                                                        <img className="img-30 b-r-5" src={element.urlImage + "/preview"} alt="" />
                                                        <span>
                                                          <img className="b-r-10" src={element.urlImage + "/preview"} alt="" />
                                                        </span>
                                                      </a>
                                                      <span className={styles["lang-txt"]}>{selectedLanguage === "en" ? element.titleAnglais : element.titleFrancais}</span>
                                                    </div>
                                                  );
                                                })}
                                                {listTypeVideo.length === 0 && (
                                                  <div className={styles["lang"] + " text-center"}>
                                                    <span className={styles["lang-txt-vide"] + " text-center"}>---Vide---</span>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </ClickAwayListener>
                                        )}
                                      </FormGroup>
                                    </Col>
                                  )}
                                  <Col md={4}>
                                    <FormGroup>
                                      <ClickAwayListener onClickAway={() => setToggleDropdownThematic(false)}>
                                        <div className={` ${styles["translate_wrapper"]} ${toggleDropdownThematic ? styles["active"] : fieldSearchThematic ? styles["field-selected__search"] : ""}`}>
                                          <div className={styles["current_lang"]}>
                                            <div
                                              className={styles["lang"]}
                                              onClick={() => {
                                                setToggleDropdownThematic(!toggleDropdownThematic);
                                                setToggleDropdownCountry(false);
                                                setToggleDropdownLanguage(false);
                                              }}
                                            >
                                              {fieldSearchThematic ? (
                                                <>
                                                  <a href="#thumb" className={styles["thumbnail"]}>
                                                    <img className="img-30 b-r-5" src={fieldSearchThematic.urlImage + "/preview"} alt="" />
                                                    <span>
                                                      <img className="b-r-10" src={fieldSearchThematic.urlImage + "/preview"} alt="" />
                                                    </span>
                                                  </a>
                                                  <span className={styles["lang-txt"]}>{fieldSearchThematic.titleFrancais}</span>
                                                  <i
                                                    onClick={e => {
                                                      e.stopPropagation();
                                                      setValue("thematicId", "");
                                                      setFieldSearchThematic(null);
                                                      setToggleDropdownThematic(false);
                                                      // handleGetListOptionSearch(filteredDocuments, +category.typeCategory);
                                                      onSubmit(getValues());
                                                    }}
                                                    className={styles["icon-reset-filed"] + " fa fa-times"}
                                                  ></i>
                                                </>
                                              ) : (
                                                String(props.t("filters.input_placeholder_thematic"))
                                              )}
                                            </div>
                                          </div>
                                          <div className={`${styles["more_lang"]} ${toggleDropdownThematic ? styles["active"] : ""}`}>
                                            {listThematic.map(element => {
                                              return (
                                                <div
                                                  key={element.thematicId}
                                                  className={styles["lang"]}
                                                  onClick={() => {
                                                    handleSetFieldThematic(element);
                                                    onSubmit(getValues());
                                                  }}
                                                >
                                                  <a href="#thumb" className={styles["thumbnail"]}>
                                                    <img className="img-30 b-r-5" src={element.urlImage + "/preview"} alt="" />
                                                    <span>
                                                      <img className="b-r-10" src={element.urlImage + "/preview"} alt="" />
                                                    </span>
                                                  </a>
                                                  <span className={styles["lang-txt"]}>{selectedLanguage === "en" ? element.titleAnglais : element.titleFrancais}</span>
                                                </div>
                                              );
                                            })}
                                            {listThematic.length === 0 && (
                                              <div className={styles["lang"] + " text-center"}>
                                                <span className={styles["lang-txt-vide"] + " text-center"}>---Vide---</span>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </ClickAwayListener>
                                    </FormGroup>
                                  </Col>
                                  {/* </Row>

                        <Row> */}
                                  { (
                                    <Col md={4}>
                                      <FormGroup>
                                        <div className={` ${styles["translate_wrapper"]} ${toggleDropdownLanguage ? styles["active"] : fieldSearchLanguage ? styles["field-selected__search"] : ""}`}>
                                          <div className={styles["current_lang"]}>
                                            <div
                                              className={styles["lang"]}
                                              onClick={() => {
                                                setToggleDropdownLanguage(!toggleDropdownLanguage);
                                                setToggleDropdownVideoType(false);
                                                setToggleDropdownCountry(false);
                                                setToggleDropdownDocumentType(false);
                                                setToggleDropdownThematic(false);
                                              }}
                                            >
                                              {fieldSearchLanguage ? (
                                                <>
                                                  <a href="#thumb" className={styles["thumbnail"]}>
                                                    {fieldSearchLanguage === "Français" ? (
                                                      <i className="flag-icon flag-icon-fr "></i>
                                                    ) : fieldSearchLanguage === "Anglais" ? (
                                                      <i className="flag-icon flag-icon-gb"></i>
                                                    ) : (
                                                      <i className="fa fa-language"></i>
                                                    )}

                                                    <span>{fieldSearchLanguage === "Français" ? <i className="flag-icon flag-icon-fr"></i> : <i className="flag-icon flag-icon-gb"></i>}</span>
                                                  </a>
                                                  <span className={styles["lang-txt"]}>{fieldSearchLanguage}</span>
                                                  <i
                                                    onClick={e => {
                                                      e.stopPropagation();
                                                      setValue("language", "");
                                                      setFieldSearchLanguage(null);
                                                      setToggleDropdownLanguage(false);
                                                      // handleGetListOptionSearch(filteredDocuments, +category.typeCategory);
                                                      onSubmit(getValues());
                                                    }}
                                                    className={styles["icon-reset-filed"] + " fa fa-times"}
                                                  ></i>
                                                </>
                                              ) : (
                                                String(props.t("filters.input_placeholder_language"))
                                              )}
                                            </div>
                                          </div>
                                          <ClickAwayListener onClickAway={() => setToggleDropdownLanguage(false)}>
                                            <div className={`${styles["more_lang"]} ${toggleDropdownLanguage ? styles["active"] : ""}`}>
                                              {listLanguage.map((element, index) => {
                                                return (
                                                  <div
                                                    key={index + "14k"}
                                                    className={styles["lang"]}
                                                    onClick={() => {
                                                      handleSetFieldLanguage(element);
                                                      onSubmit(getValues());
                                                    }}
                                                  >
                                                    <a href="#thumb" className={styles["thumbnail"]}>
                                                      {element === "Français" ? (
                                                        <i className="flag-icon flag-icon-fr"></i>
                                                      ) : element === "Anglais" ? (
                                                        <i className="flag-icon flag-icon-gb"></i>
                                                      ) : (
                                                        <i className="fa fa-language"></i>
                                                      )}
                                                      <span>
                                                        {element === "Français" ? (
                                                          <i className="flag-icon flag-icon-fr"></i>
                                                        ) : element === "Anglais" ? (
                                                          <i className="flag-icon flag-icon-gb"></i>
                                                        ) : (
                                                          <i className="fa fa-language"></i>
                                                        )}
                                                      </span>
                                                    </a>
                                                    <span className={styles["lang-txt"]}>{element}</span>
                                                  </div>
                                                );
                                              })}
                                              {listLanguage.length === 0 && (
                                                <div className={styles["lang"] + " text-center"}>
                                                  <span className={styles["lang-txt-vide"] + " text-center"}>---Vide---</span>
                                                </div>
                                              )}
                                            </div>
                                          </ClickAwayListener>
                                        </div>
                                      </FormGroup>
                                    </Col>
                                  )}
                                  <Col md={4}>
                                    <FormGroup>
                                      <div className={` ${styles["translate_wrapper"]} ${toggleDropdownCountry ? styles["active"] : fieldSearchCountry ? styles["field-selected__search"] : ""}`}>
                                        <div className={styles["current_lang"]}>
                                          <div
                                            className={styles["lang"]}
                                            onClick={() => {
                                              setToggleDropdownCountry(!toggleDropdownCountry);
                                              setToggleDropdownVideoType(false);
                                              setToggleDropdownDocumentType(false);
                                              setToggleDropdownThematic(false);
                                              setToggleDropdownLanguage(false);
                                            }}
                                          >
                                            {fieldSearchCountry ? (
                                              <>
                                                <a href="#thumb" className={styles["thumbnail"]}>
                                                  <img className="img-30 b-r-5" src={fieldSearchCountry.urlImage + "/preview"} alt="" />
                                                  <span>
                                                    <img className="b-r-10" src={fieldSearchCountry.urlImage + "/preview"} alt="" />
                                                  </span>
                                                </a>
                                                <span className={styles["lang-txt"]}>{fieldSearchCountry.titleFrancais}</span>
                                                <i
                                                  onClick={e => {
                                                    e.stopPropagation();
                                                    setValue("countryId", "");
                                                    setFieldSearchCountry(null);
                                                    setToggleDropdownCountry(false);
                                                    // handleGetListOptionSearch(filteredDocuments, +category.typeCategory);
                                                    onSubmit(getValues());
                                                  }}
                                                  className={styles["icon-reset-filed"] + " fa fa-times"}
                                                ></i>
                                              </>
                                            ) : (
                                              String(props.t("filters.input_placeholder_country"))
                                            )}
                                          </div>
                                        </div>
                                        <ClickAwayListener onClickAway={() => setToggleDropdownCountry(false)}>
                                          <div className={`${styles["more_lang"]} ${toggleDropdownCountry ? styles["active"] : ""}`}>
                                            {listCountry.map(element => {
                                              return (
                                                <div
                                                  key={element.countryId}
                                                  className={styles["lang"]}
                                                  onClick={() => {
                                                    handleSetFieldCountry(element);
                                                    onSubmit(getValues());
                                                  }}
                                                >
                                                  <a href="#thumb" className={styles["thumbnail"]}>
                                                    <img className="img-30 b-r-5" src={element.urlImage + "/preview"} alt="" />
                                                    <span>
                                                      <img className="b-r-10" src={element.urlImage + "/preview"} alt="" />
                                                    </span>
                                                  </a>
                                                  <span className={styles["lang-txt"]}>{selectedLanguage === "en" ? element.titleAnglais : element.titleFrancais}</span>
                                                </div>
                                              );
                                            })}
                                            {listCountry.length === 0 && (
                                              <div className={styles["lang"] + " text-center"}>
                                                <span className={styles["lang-txt-vide"] + " text-center"}>---Vide---</span>
                                              </div>
                                            )}
                                          </div>
                                        </ClickAwayListener>
                                      </div>
                                    </FormGroup>
                                  </Col>

                                  <Col md={4}>
                                    <div className={styles["search-date"]}>
                                      <FormGroup className={styles["form-group__date-picker"]}>
                                        <DatePicker
                                          className={
                                            searchFieldDate !== null && searchFieldDate !== ""
                                              ? styles["field-selected__search"] + " form-control " + styles["field-datepicker__search"]
                                              : " form-control " + styles["field-datepicker__search"]
                                          }
                                          selected={searchFieldDate ? new Date(searchFieldDate) : null}
                                          onChange={(e: Date) => {
                                            setValue("dateSupport", String(e?.getFullYear()));
                                            setSearchFieldDate(String(e?.getFullYear()));
                                            onSubmit(getValues());
                                          }}
                                          maxDate={new Date()}
                                          placeholderText={String(props.t("filters.input_placeholder_date"))}
                                          dateFormat="yyyy"
                                          showYearPicker
                                        />
                                        {searchFieldDate !== null && searchFieldDate !== "" && (
                                          <i
                                            onClick={() => {
                                              setSearchFieldDate(null);
                                              setValue("dateSupport", "");
                                              // handleGetListOptionSearch(filteredDocuments, +category.typeCategory);
                                              onSubmit(getValues());
                                            }}
                                            className={styles["icon-reset-datepicker"] + " fa fa-times"}
                                          ></i>
                                        )}
                                      </FormGroup>

                                      <Button className={styles["button-reset"]} onClick={resetFormSeacrch} ref={resetRef} type="reset" color="link" outline size="sm">
                                        <i className={styles["icon_reset"] + " fa fa-refresh"}></i>
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                              {/* </CardHeader> */}
                            </div>
                          </div>
                        </div>
                        {/* <CardBody className={styles["documents-card-body"] + " p-0"}>
                      <Card> */}
                        <Row>
                          <Col className={styles["col-media"]} md={12}>
                            {+category?.typeCategory === 0 ? (
                              <Documents
                                categoryId={location.pathname.split("/")[3]}
                                filteredDocuments={filteredDocuments}
                                handleGetListSupport={handleGetListSupport}
                                setFilteredDocuments={handleSetListMedia}
                                elementPerPage={elementPerPage}
                                currentPage={currentPage}
                                paginateAndSorting={paginateAndSorting}
                                resetAllFieldSearch={resetAllFieldSearch}
                                setSortOrder={setSortOrder}
                                isListDisplayMode={isListDisplayMode}
                              />
                            ) : +category?.typeCategory === 1 ? (
                              <Videotheque
                                categoryId={location.pathname.split("/")[3]}
                                filteredDocuments={filteredDocuments}
                                paginateAndSorting={paginateAndSorting}
                                setFilteredDocuments={handleSetListMedia}
                                handleGetListSupport={handleGetListSupport}
                                elementPerPage={elementPerPage}
                                currentPage={currentPage}
                                resetAllFieldSearch={resetAllFieldSearch}
                                setSortOrder={setSortOrder}
                                setColumnName={setSortColumn}
                                isListDisplayMode={isListDisplayMode}
                              ></Videotheque>
                            ) : (
                              <div>
                                <GalleryImages
                                  categoryId={location.pathname.split("/")[3]}
                                  filteredDocuments={filteredDocuments}
                                  paginateAndSorting={paginateAndSorting}
                                  setFilteredDocuments={handleSetListMedia}
                                  handleGetListSupport={handleGetListSupport}
                                  setTotlaElement={setTotlaElement}
                                  resetAllFieldSearch={resetAllFieldSearch}
                                  elementPerPage={elementPerPage}
                                  currentPage={currentPage}
                                  setSortOrder={setSortOrder}
                                  isListDisplayMode={isListDisplayMode}
                                  setSortColumnTitle={setSortColumnExpo}
                                  filterLanguage={fieldSearchLanguage}
                                />
                              </div>
                            )}
                            <div className="m-t-10">
                              <br />
                              <Pagination pageNumbers={pageNumbers} paginate={paginateAndSorting} currentPage={currentPage}></Pagination>
                            </div>
                          </Col>
                        </Row>
                        {/* </Card>
                    </CardBody> */}
                        {/* </Card> */}
                      </div>
                    </Col>
                  ) : (
                    <ThematicFolder></ThematicFolder>
                  )}
                </Row>
              </Container>
            </div>
            <Footer />
          </div>
        </div>
      ) : (
        <ThematicFolder></ThematicFolder>
      )}
      <Modal isOpen={openModalAddSupport} size="lg">
        <ModalBody className={styles["modal-body"]}>
          <div>
            <h6 className={styles["title-model"] + " p-20"}>
              {+category?.typeCategory === 0 ? props.t("title_add_document") : +category?.typeCategory === 1 ? props.t("title_add_video") : props.t("title_add_exhibit")}
            </h6>
          </div>

          {+category?.typeCategory === 0 ? (
            <AddSupport
              type={category?.typeCategory}
              getListSupport={handleGetListSupport}
              closeToggle={handleClickOpenModalAddSupport}
              categoryId={location.pathname.split("/")[3]}
              resetAllFieldSearch={resetAllFieldSearch}
              path={location.pathname.split("/")[2]}
            />
          ) : +category?.typeCategory === 1 ? (
            <AddVideo
              type={category?.typeCategory}
              getListSupport={handleGetListSupport}
              closeToggle={handleClickOpenModalAddSupport}
              categoryId={location.pathname.split("/")[3]}
              resetAllFieldSearch={resetAllFieldSearch}
              path={location.pathname.split("/")[2]}
            ></AddVideo>
          ) : (
            <AddImagesGallery
              handlerListener={handleGetListSupport}
              closeToggle={handleClickOpenModalAddSupport}
              categoryId={location.pathname.split("/")[3]}
              setFilteredDocuments={setFilteredDocuments}
              resetAllFieldSearch={resetAllFieldSearch}
              path={location.pathname.split("/")[2]}
            ></AddImagesGallery>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CategoryDetails);
